import { createContext } from 'react';

import { locale } from './functions';

export const LocaleContext = createContext(locale());

LocaleContext.displayName = 'Locale Context';
